import {
  mapGetters
} from 'vuex'

import i18n from '../../lang/i18n'

export default {
  data () {
    return {
      checkedAndFoundPdf: this.PdfCheckEnum.UNCHECKED,
      showPageSelectSubMenu: false
    }
  },
  beforeCreate () {
    this.leftRightArrayPrint = [
      { id: 'left', label: i18n.t('cci_nav_bar_select_left_page_title') },
      { id: 'right', label: i18n.t('cci_nav_bar_select_right_page_title') }
    ]
    this.leftRightArrayCrop = [
      { id: 0, label: i18n.t('cci_nav_bar_select_left_page_title') },
      { id: 1, label: i18n.t('cci_nav_bar_select_right_page_title') }
    ]
    this.PdfCheckEnum = {
      UNCHECKED: -1,
      CHECKED_NOT_FOUND: 0,
      CHECKED_AND_FOUND: 1
    }
  },
  mounted () {
    this.applySettings(this.settings)
  },
  computed: {
    isPagesShowing: function () {
      var pagesShowing = (this.$route.name === 'pages')

      this.$nextTick(function () {
        var sectionBarElem = document.getElementById('sections-bar')
        if (sectionBarElem !== null) {
          if (!pagesShowing) {
            sectionBarElem.style.display = 'none'
          } else if (this.sections.length > 1) {
            sectionBarElem.style.display = 'block'
          }
        }
      })
      return pagesShowing
    },
    title: function () {
      if (this.settings !== undefined) {
        document.title = this.settings.navigationBarTitle
        return this.settings.navigationBarTitle
      }
    },
    isArticlesEmpty: function () {
      if (this.articles === undefined || this.articles.length < 1) {
        return true
      }
      return false
    },
    isShowingSinglePage () {
      return this.currentPage !== undefined && !this.currentPage.secondPage
    },
    hasSinglePagePdf () {
      let cur = this.currentPage
      return cur.firstPage &&
        cur.firstPage.pdf &&
        (!cur.secondPage || cur.secondPage.pdf) &&
        this.checkedAndFoundPdf === this.PdfCheckEnum.CHECKED_AND_FOUND
    },
    hasSportsXtraSection: function() {
      return (this.sections[this.sections.findIndex(x => x.name.toUpperCase() == 'SPORTSXTRA')]) !== undefined
    },
    displaySocialSharingButton: function () {
      if (this.settings !== undefined &&
        this.settings.enableSocialSharing &&
        this.currentArticle !== undefined &&
        (this.$route.name === 'article-mobile' || this.$route.name === 'articles')) {
        if (this.settings.enableOnlineURLSocialSharing) {
          let onlineURL = this.currentArticle.attributes.OnlineURL
          return onlineURL !== undefined && onlineURL !== ''
        }
        return true
      }
      return false
    },
    ...mapGetters({
      currentArticle: 'getCurrentArticle',
      articles: 'getArticles',
      currentPage: 'getCurrentPage',
      homeUrl: 'getHomeUrl',
      settings: 'getSettings',
      opsUrl: 'getOpsUrl',
      pages: 'getPages',
      sections: 'getSections',
      isFullPageViewMode: 'getPageViewMode'
    })
  },
  watch: {
    settings: function (newValue) {
      this.applySettings(newValue)
    },
    // isMobileSize: function (newValue) {
    //   this.layoutNavigationBarSizes()
    // },
    currentPage: function (newValue) {
      let cropMenuElem = document.getElementById('cropMenu')
      if (this.settings.enableCropPage && cropMenuElem !== null) {
        let cropIconElem = document.getElementsByClassName('nav-icon-crop')[0]
        if (newValue.firstPage.interstitialAdAfterPage !== undefined) {
          cropMenuElem.style.opacity = '0.5'
          cropIconElem.style.cursor = 'auto'
        } else {
          cropMenuElem.style.opacity = '1.0'
          cropIconElem.style.cursor = 'pointer'
        }
      }

      if (this.checkedAndFoundPdf !== this.PdfCheckEnum.UNCHECKED) return
      if (!newValue && newValue.firstPage && newValue.firstPage.pdf) return

      let url = this.getEncodedResourceUrl(newValue.firstPage.pdf, newValue.firstPage.attributes.LastRev)

      // make HEAD request to check whether this issue has PDFs
      this.$http.head(url)
        .then(() => {
          this.checkedAndFoundPdf = this.PdfCheckEnum.CHECKED_AND_FOUND
        }, () => {
          this.checkedAndFoundPdf = this.PdfCheckEnum.CHECKED_NOT_FOUND
        })
    }
  },
  methods: {
    applySettings (settings) {
      if (settings !== undefined) {
        var header = document.getElementsByClassName('header')[0]
        if (header) {
          header.style.backgroundColor = settings.navigationBarBackgroundColor
          header.style.borderBottomColor = settings.sectionsBarBorderColor
          document.getElementById('nav-right-pages').style.backgroundColor = settings.navigationBarBackgroundColor
        }

        var title = document.getElementsByClassName('navbar-brand')[0]
        if (title) { title.style.color = settings.navigationBarTitleColor }


        // this.setNavIcon('nav-icon-home', settings.homeIconURL)
        // this.setNavIcon('nav-icon-article', settings.articleListIconURL)
        // this.setNavIcon('nav-icon-zoom-in', settings.zoomInIconURL)
        // this.setNavIcon('nav-icon-zoom-out', settings.zoomOutIconURL)
        // this.setNavIcon('nav-icon-full', settings.fullscreenIconURL)
        // this.setNavIcon('nav-icon-thumbnail', settings.issueOverviewIconURL)
        // this.setNavIcon('nav-icon-scrubber', settings.scrubberIconURL)
        // this.setNavIcon('nav-icon-pages', settings.pagesIconURL)
        // this.setNavIcon('text-size-icon', settings.incrementFontSizeIconURL)
        // this.setNavIcon('nav-text-size-icon-increment', settings.incrementFontSizeIconURL)
        // this.setNavIcon('text-size-icon-small', settings.decrementFontSizeIconURL)
        // this.setNavIcon('nav-text-size-icon-decrement', settings.decrementFontSizeIconURL)

        if (settings.navigationBarTitleIcon !== '') {
          var titleIcon = document.getElementById('title-icon')
          if (titleIcon) {
            titleIcon.style.backgroundImage = 'url(' + settings.navigationBarTitleIcon + ')'
            titleIcon.style.backgroundSize = 'cover'

            // if (settings.navigationBarTitleIcon !== 'SET') {
            //   titleIcon.style.backgroundImage = ''
            //   titleIcon.style.width = '100%'
            //   // titleIcon.style.backgroundSize = 'cover'
            // }

          }
        }
        this.layoutNavigationBarSizes()
      }
    },
    layoutNavigationBarSizes () {
      if (this.settings == null) {
        return
      }
      // var navRight = document.getElementById('nav-right-pages')
      // var navRightArticleList = document.getElementById('nav-right-article-list')
      // var navHead = document.getElementById('navbar-header')
      // var navLeft = document.getElementById('nav-left-pages')

      // if (navRight !== null && navHead !== null && navRightArticleList !== null) {
      //   if (this.isPagesShowing && this.settings.enableDownloadOfPages && this.isMobileSize) {
      //     navRight.style.width = '140px'
      //     navRightArticleList.style.width = '140px'
      //     navLeft.style.width = '70px'
      //     var remainingSpace = window.innerWidth - 140 - 70 - 20
      //     navHead.style.width = '' + remainingSpace + 'px'
      //   } else if (this.isPagesShowing && !this.settings.enableDownloadOfPages && this.isMobileSize) {
      //     navRight.style.width = '70px'
      //     navRightArticleList.style.width = '70px'
      //     navLeft.style.width = '70px'
      //     var remainingSpace = window.innerWidth - 70 - 70 - 20
      //     navHead.style.width = '' + remainingSpace + 'px'
      //   } else {
      //     navRight.style.width = '50%'
      //     navRightArticleList.style.width = '50%'
      //     navHead.style.width = '15%'
      //     navLeft.style.width = '35%'
      //   }
      // }
    },
    printArticle() {
      this.$cciEventTrackingPlugin.trackEvent('ContextArticleView', 'ActionArticlePrintButtonClick', this.currentArticle)
      let iframe = document.getElementById(this.currentArticle.id + '-article')
      if (iframe !== undefined && iframe.contentWindow) {
        iframe.contentWindow.print()
      }
    },
    // gotoSportsExtra() {
    //   this.$store.commit('setSportsExtraMenuSelected', true)
    // },
    toggleScrubber () {
      this.$cciEventTrackingPlugin.trackEvent('ContextPageView', 'ActionPagesScrubberButtonClick', this.currentPage.firstPage, this.currentPage.firstPage.attributes.Page)
      this.$store.commit('toggleScrubberVisible')
    },
    openIssueOverview (printAndDownload, event) {
      if (!printAndDownload) {
        this.$cciEventTrackingPlugin.trackEvent('ContextPageView', 'ActionPagesIssueOverviewButtonClick')
      } else {
        if (event.target.className === 'nav-icon nav-icon-download') {
          // downlad button
          this.$cciEventTrackingPlugin.trackEvent('ContextPageView', 'ActionPagesIssueDownloadButtonClick')
        } else if (event.target.className === 'nav-icon nav-icon-print-download') {
          // print button
          this.$cciEventTrackingPlugin.trackEvent('ContextPageView', 'ActionPagesIssuePrintButtonClick')
        }
      }

      this.$store.commit('setShowIssueOverview', {val: true, printAndDownload: printAndDownload})
      document.getElementsByTagName('body')[0].style.overflow = 'hidden'
      // $('body').css('overflow', 'hidden')
    },
    // handleGamesMenuClick () {
    //   if (this.settings.gamesUrl !== '') {
    //     window.open(this.settings.gamesUrl, '_blank')
    //   }
    // },
    handleFAQMenuClick () {
      if (this.settings.helpUrl !== '') {
        window.location.href = this.settings.helpUrl
      }
    },
    downloadIssue () {
      let confirmed = confirm("Are you sure, you want to download?")
      if (confirmed) {
        // remove /OPS/ from opsUrl
        let url = this.opsUrl
        url = url.substr(0, url.lastIndexOf('/'))
        url = url.substr(0, url.lastIndexOf('/'))

        let postData = []
        // for (let page of this.pages) {
        //   if (page.firstPage.interstitialInfo !== null) {
        //     continue
        //   }
        //   postData.push('OPS/' + page.firstPage.pdf)
        //   if (page.secondPage) {
        //     postData.push('OPS/' + page.secondPage.pdf)
        //   }
        // }
        postData.push('fullIssue')
        // Make post request for issue and save response as download
        // Don't see any good way of doing this, so create an a tag with download attribute and click it
        this.$http.post(url + '/pagespdf', postData, {responseType: 'blob'})
          .then((response) => {
            let filename = (response.headers.get('Content-Disposition') || '').split('filename=')[1]
            response.blob()
              .then((data) => {
                let link = document.createElement('a')
                link.href = window.URL.createObjectURL(data)
                link.download = filename
                document.body.appendChild(link)
                link.click()
              }, (response) => { console.log(response) })
          }, (response) => { console.log(response) })
      }
    },
    leftRightPosition (e) {
      const el = e.currentTarget.children.item(0)
      const rect = el.getBoundingClientRect()
      return {
        x: rect.right,
        y: rect.bottom,
        direction: 'left'
      }
    },
    initiateCrop (pageSide) {
      if (pageSide === 0) {
        this.$cciEventTrackingPlugin.trackEvent('ContextPageView', 'ActionPagesCropButtonClick', this.currentPage.firstPage, this.currentPage.firstPage.attributes.Page)
      } else if (pageSide === 1) {
        this.$cciEventTrackingPlugin.trackEvent('ContextPageView', 'ActionPagesCropButtonClick', this.currentPage.secondPage, this.currentPage.secondPage.attributes.Page)
      }

      this.$store.commit('toggleCropVisible', pageSide)
      this.showPageSelectSubMenu = false
    },
    handleCropRequest () {
      if (this.isShowingSinglePage) {
        this.initiateCrop(0)
      } else {
        this.showPageSelectSubMenu = !this.showPageSelectSubMenu
      }
    },
    downloadSinglePage (leftRight) {
      let page = (this.isShowingSinglePage || leftRight === 'left') ? this.currentPage.firstPage : this.currentPage.secondPage
      var pdfUrl = page.pdf
      if (page.interstitialInfo !== null) {
        if (this.isPortrait()) {
          pdfUrl = page.interstitialInfo.portraitPdf
        } else {
          pdfUrl = page.interstitialInfo.landscapePdf
        }
      }
      window.open(this.getEncodedResourceUrl(pdfUrl, page.attributes.LastRev), '_blank')
    },
    openFullScreen () {
      if (document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement) {
        this.$cciEventTrackingPlugin.trackEvent('ContextPageView', 'ActionPagesFullscreenModeOffButtonClick', this.currentPage.firstPage, this.currentPage.firstPage.attributes.Page)
        if (document.exitFullscreen) {
          document.exitFullscreen()
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen()
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen()
        } else if (document.webkitExitFullscreen) {
          document.webkitExitFullscreen()
        }
      } else {
        this.$cciEventTrackingPlugin.trackEvent('ContextPageView', 'ActionPagesFullscreenModeOnButtonClick', this.currentPage.firstPage, this.currentPage.firstPage.attributes.Page)
        var elem = document.body
        if (elem.webkitRequestFullscreen) {
          elem.webkitRequestFullscreen()
        } else if (elem.mozRequestFullScreen) {
          elem.mozRequestFullScreen()
        } else if (elem.msRequestFullscreen) {
          elem.msRequestFullscreen()
        }
      }
    },
    openSharing () {
      this.$cciEventTrackingPlugin.trackEvent('ContextArticleView', 'ActionArticleShareButtonClick', this.currentArticle, window.location.href)
      this.$store.commit('setShowSharing', true)
    },
    routeToArticleList () {
      this.$cciEventTrackingPlugin.trackEvent('ContextPageView', 'ActionPagesArticleListButtonClick')
      if (typeof googletag !== 'undefined' && googletag.apiReady) {
        googletag.destroySlots()
      }

      if (!this.isPhone()) {
        this.resetPagesLayout()
        let articleIndex = this.articles.indexOf(this.currentArticle).toString()
        if (articleIndex !== '-1') {
          this.$router.push({
            name: 'articles',
            params: {
              articleNr: articleIndex
            }
          })
        } else {
          this.$router.push({
            name: 'articles',
            params: {
              articleNr: '0'
            }
          })
        }
      } else {
        document.getElementById('app').style.overflow = 'auto'
        this.$router.push({
          name: 'articles-mobile'
        })
      }
    },
    routeToPages () {
      if (this.isPhone()) {
        document.getElementById('app').style.overflow = 'hidden'
      }
      this.$router.push({
        name: 'pages',
        params: {
          pageNr: this.currentPage.firstPage.pageNumber
        }
      })
    },
    routeToHome () {
      if (this.settings.homeNavigationUrl !== '') {
        window.location.href = this.settings.homeNavigationUrl
      } else {
        window.location.href = this.homeUrl
      }
    },
    zoom (zoomIn) {
      if (zoomIn) {
        var event1 = new CustomEvent('buttonZoomIn')
        window.dispatchEvent(event1)
      } else {
        var event2 = new CustomEvent('buttonZoomOut')
        window.dispatchEvent(event2)
      }

      // this.$store.commit('setZoomLevelButton', zoomIn)
    },
    incrementFontSize () {
      this.$store.commit('setFontSize', true)
    },
    decrementFontSize () {
      this.$store.commit('setFontSize', false)
    },
    toggleSideMenu () {
      let burgerButton = document.getElementById('burger-button')
      let slider = document.getElementById('nav-right-pages')
      burgerButton.classList.toggle('rotate-90-degree')
      slider.classList.toggle('move-right')
    },
    // setNavIcon (iconClass, url) {
    //   if (url !== '') {
    //     var icon = document.getElementsByClassName(iconClass)[0]
    //     icon.style.background = 'url(' + url + ')'
    //     icon.style.backgroundSize = 'cover'
    //   }
    // },
    resetPagesLayout () {
      let pagesSwiperContainer = document.getElementById('pages-swiper-container')
      let sectionBar = document.getElementById('sections-bar')
      let nextButton = document.getElementById('next-page-button')
      let prevButton = document.getElementById('prev-page-button')

      pagesSwiperContainer.style.overflow = 'hidden'
      if (sectionBar !== null) {
        sectionBar.style.visibility = 'visible'
      }
      nextButton.style.display = 'inline-block'
      prevButton.style.display = 'inline-block'
    },
    setPageViewMode () {
      this.$store.commit('togglePageViewMode')
    },
    currentArticleIsOnline () {
      if (this.currentArticle === undefined) {
        return false
      }
      let onlineURL = this.currentArticle.attributes.OnlineURL
      return this.settings.enableOnlineURLArticles !== undefined && this.settings.enableOnlineURLArticles && onlineURL !== undefined && onlineURL !== ''
    }
  }
}
